import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import type { MenuProps } from 'antd';
import { Dropdown, Modal } from 'antd';
import { DeleteOutlined, ExclamationCircleOutlined, MoreOutlined } from '@ant-design/icons';
import { routePaths } from 'router';
import { useDeleteTrip } from 'api/trips/use-delete-trip.ts';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import type { TDropdownChangeInfo } from 'types/dropdown-change-info';

interface TripExtraActions {
  tripId: number;
}

export const TripExtraActionsComponent: React.FC<TripExtraActions> = (props) => {
  const { tripId } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutateAsync: deleteTrip } = useDeleteTrip();

  const [modal, contextHolder] = Modal.useModal();
  const [isActiveControl, setIsActiveControl] = useState(false);
  const deactivateWithTimeout = () => {
    setTimeout(() => setIsActiveControl(false), 300);
  };

  const confirm = () => {
    modal.confirm({
      title: t('common:confirm'),
      icon: <ExclamationCircleOutlined />,
      content: t('common:delete_confirm_text'),
      okText: t('common:delete'),
      cancelText: t('common:cancel'),
      onCancel: () => deactivateWithTimeout(),
      onOk: async () => {
        await deleteTrip({ tripId });
        deactivateWithTimeout();
        navigate(routePaths.trips);
      },
    });
  };

  const handleDropdownClick: MenuProps['onClick'] = ({ key }) => {
    if (key === 'delete') {
      confirm();
    }
  };

  const handleDropdownOpenChange = (value: boolean, info: TDropdownChangeInfo) => {
    if (info.source === 'trigger') {
      setIsActiveControl(value);
    }
  };

  return (
    <>
      <Dropdown
        key='more'
        trigger={['click']}
        menu={{
          items: [
            {
              key: 'delete',
              label: t('common:delete'),
              icon: <DeleteOutlined />,
            },
          ],
          onClick: handleDropdownClick,
        }}
        placement='bottomLeft'
        onOpenChange={handleDropdownOpenChange}>
        <MoreOutlined style={{ fontSize: 20 }} />
      </Dropdown>
      {isActiveControl ? contextHolder : null}
    </>
  );
};

export const TripExtraActions = withRoleGuard(TripExtraActionsComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.transport_manager,
]);
